import React, {useCallback, useRef} from 'react'

import {AddUser_Manager} from "../../model/manager"
import ModalAddUser_AddToWorkspace from "./add-to-workspace"
import VScroll from "../../../../gd-components/scrolling/custom-v-scroll/v-scroll"
import Button, {ButtonType} from "../../../../gd-components/buttons/gd-button/gd-button-ui5-new"
import {AddUserType} from "../../@const"
import ModalAddUser_AddToProject from "./add-to-project"
import ModalAddUser_AddToTaskOrChat from "./add-to-task"
import ModalAddUser_NoUsersFound from "./not-found/not-found";
import ModalAddUser_SubmitButton from "./submit-button"
import ModalV5_Header from "../../../../../app/ui/modal/v5/header/header";

type Props = {
    manager     : AddUser_Manager
    className?: string
}

export default function ModalAddUser_Right(props: Props) {

    const refSubmitButton: any = useRef()

    const onSubmit = useCallback(() => {
        refSubmitButton.current.setType(ButtonType.BUSY)
        props.manager.submit()
    }, [refSubmitButton.current])

    let  content: any

    // const searchEnabled         = props.manager.searchEnabled
    const noProjectUsers        = !props.manager.projectUsersToAdd.hasAvailable
    const noWorkspaceUsers      = !props.manager.workspaceUsersToAdd.hasAvailable
    const noCompanyUsers        = !props.manager.companyUsersToAdd.hasAvailable

    const showProjectUsers      = /*!searchEnabled ||*/ !noProjectUsers
    const showWorkspaceUsers    = /*!searchEnabled ||*/ !noWorkspaceUsers
    const showCompanyUsers      = /*!searchEnabled ||*/ !noCompanyUsers && (!props.manager.workspace || props.manager.workspace?.project.acl.canAddCompanyUsers)

    const noUsersFound          = noProjectUsers && noWorkspaceUsers && noCompanyUsers

    if (noUsersFound) {
        content = <ModalAddUser_NoUsersFound/>
    } else {
        switch(props.manager.type) {
            case AddUserType.WORKSPACE_USER:
                content = (
                    <>
                        {showCompanyUsers &&
                            <ModalAddUser_AddToWorkspace showWorkspaceAccess={true} manager={props.manager} />}
                    </>
                )
                break

            case AddUserType.PROJECT_USER:
                // projects in workspace - new
                if (props.manager.workspace) {
                    content = (<>
                        {showWorkspaceUsers &&
                            <ModalAddUser_AddToProject manager={props.manager} />}

                        {showCompanyUsers &&
                            <ModalAddUser_AddToWorkspace className              = "m-t-25"
                                                         showWorkspaceAccess    = {true}
                                                         showProjectAccess      = {true}
                                                         manager                = {props.manager}/>}

                    </>)
                } else {
                    content = (<>
                        {showCompanyUsers &&
                            <ModalAddUser_AddToWorkspace showProjectAccess  = {true}
                                                         manager            = {props.manager}/>}

                    </>)
                }
                break

            case AddUserType.TASK_USER:
            case AddUserType.CHAT_USER:
            case AddUserType.MEETING_USER:
                if (props.manager.workspace) {
                    const workspaceClasses = Classes({
                        "m-t-25": showProjectUsers
                    })

                    const companyClasses = Classes({
                        "m-t-25": showProjectUsers || showWorkspaceUsers
                    })

                    content = (
                        <>
                            {showProjectUsers &&
                                <ModalAddUser_AddToTaskOrChat manager={props.manager}/>}

                            {showWorkspaceUsers &&
                                <ModalAddUser_AddToProject className    = {workspaceClasses}
                                                           manager      = {props.manager}/>}

                            {showCompanyUsers &&
                                <ModalAddUser_AddToWorkspace className              = {companyClasses}
                                                             showWorkspaceAccess    = {true}
                                                             showProjectAccess      = {true}
                                                             manager                = {props.manager}/>}
                        </>
                    )
                } else {
                    const companyClasses = Classes({
                        "m-t-25": showProjectUsers
                    })

                    const isMeeting = props.manager.type === AddUserType.MEETING_USER

                    content = (
                        <>
                            {showProjectUsers &&
                                <ModalAddUser_AddToTaskOrChat
                                    showMeetingRole = {isMeeting}
                                    manager         = {props.manager}
                                />
                            }

                            {showCompanyUsers &&
                                <ModalAddUser_AddToWorkspace
                                    className           = {companyClasses}
                                    showProjectAccess   = {!isMeeting}
                                    showMeetingRole     = {isMeeting}
                                    manager             = {props.manager}
                                />
                            }
                        </>
                    )
                }
                break

            default:
                throw new Error(`Unknown manager type ${props.manager.type}`)
        }
    }

    return (
        <div className="flex-column-left-top flex-1 txt-truncate">

            <ModalV5_Header title={props.manager.modalTitle} underline={true}/>

            <VScroll className="flex-column flex-1" containerClass="p-h-30 p-v-20">
                {content}
            </VScroll>

            <div className="h-90 w-100p ui5-border-top flex-row-center-center">
                <ModalAddUser_SubmitButton ref={refSubmitButton}
                                           manager={props.manager}
                                           onSubmit={onSubmit}/>
            </div>

        </div>
    )
}
